import { unAuthorizedErrorHandler } from 'common/ApiWrapper';

export function logoutErrorHandler(errorCode: unknown): boolean {

  if (errorCode === 401 || errorCode === 440) {
    unAuthorizedErrorHandler();
    return true;
  }

  // Fallback to string-based checks if no numeric status is available
  const msg =
    typeof errorCode === 'string'
      ? errorCode
      : (errorCode as any)?.message ?? (errorCode as any)?.error;

  if (typeof msg === 'string' && (msg.includes('401') ?? msg.includes('440'))) {
    unAuthorizedErrorHandler();
    return true;
  }

  return false;
}
